/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHashHistory } from 'vue-router'
import { useRouteStore } from '../stores/routes';
import * as Sentry from "@sentry/vue";

import Index from '@/pages/index.vue';
import Viewer from '@/pages/viewer.vue';
import Privacy from '@/pages/privacy.vue';



const routes = [
  {
    path: '/',
    name: 'Listing',
    component: Index,
    props: true
  },
  {
    path: '/viewer/:file',
    name: 'Viewer',
    component: Viewer,
    props: true
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: Privacy,
  }
]


const router = createRouter({
  history: createWebHashHistory(),
  routes,
})


router.afterEach((to, from, failure) => {
  const routeStore = useRouteStore()
  routeStore.goto(from)

  if (failure) {
    Sentry.captureException(failure);
  }
});

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (!localStorage.getItem('vuetify:dynamic-reload')) {
      console.log('Reloading page to fix dynamic import error')
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    } else {
      console.error('Dynamic import error, reloading page did not fix it', err)
    }
  } else {
    console.error(err)
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

export default router
